import {
    Sprite,
} from "pixi.js";
import { Panel } from "./Panel";
import { LoadContext } from "../../../utils";
import { Focusable, InteractiveWrapper, Switch } from '../../../ui';
import { Game } from "../../../game";

export class BackgroundArt extends Panel
{
    private onState:Sprite;
    private offState:Sprite;
    private switch:Switch;

    public static preload() {
        LoadContext.current.add('Settings', './assets/accessibility/Settings{size}.json');
    }

    constructor( game:Game )
    {
        super(
            game,
            "Background Art",
            {
                title: "CYB_Panel1_BackgroundArt",
                explain: 'CYB_Panel1_BG_Explanation',
                settings: 'CYB_Panel1_BG_Settings',
            },
            {width: 656, height: 255}
        );

        const icon:Sprite = new Sprite( LoadContext.current.getSpritesheet('Settings').textures['icon_bgart'] );
        icon.position.set( this.icon_x, this.icon_y );
        this.addChild( icon );

        this.switch = new Switch();
        this.switch.position.set( 130, 155 );

        this.switch.on( "switchChanged", (newValue:boolean)=>{
            this.game.vo.stop();
            this.settings.showBackgroundArt.value = newValue;
            const eventName: string = newValue ? "background_art_on" : "background_art_off";
            this.game.logEvent("change_setting", eventName);
            this.updateToMatchSetting();
            this.playSwitchVO( this.switch );
        });
        this.disposables.add(new InteractiveWrapper(this.switch, {
            onHover: () => {
                this.playSwitchHover( this.switch );
            },
            onFocus: () => {
                this.playSwitchHover( this.switch, true );
            },
            onTap: () => {}
        }));
        this.addChild( this.switch );

        this.onState = new Sprite( LoadContext.current.getSpritesheet('Settings').textures['icon_bgart0001'] );
        this.onState.position.set( 425, 100 );
        this.addChild(this.onState);

        this.offState = new Sprite( LoadContext.current.getSpritesheet('Settings').textures['icon_bgart0002'] );
        this.offState.position.set( 425, 100 );
        this.addChild(this.offState);

        this.updateToMatchSetting();
    }

    getFocusItems():Focusable[]
    {
        let items = super.getFocusItems();
        return items.concat( [this.switch] );
    }

    updateToMatchSetting()
    {
        super.updateToMatchSetting();
        this.switch.isOn = this.settings.showBackgroundArt.value;
        this.updateDisplayState( this.settings.showBackgroundArt.value );
    }

    updateDisplayState( isOn:boolean = true ) {
        this.onState.visible = isOn;
        this.offState.visible = !isOn;
    }

    destroy()
    {
        super.destroy();
    }
}